import { render, staticRenderFns } from "./QuestionStatistics.vue?vue&type=template&id=c4b1bbba&scoped=true"
import script from "./QuestionStatistics.vue?vue&type=script&lang=js"
export * from "./QuestionStatistics.vue?vue&type=script&lang=js"
import style0 from "./QuestionStatistics.vue?vue&type=style&index=0&id=c4b1bbba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b1bbba",
  null
  
)

export default component.exports